// Top ngân hàng VN phổ biến — có thể mở rộng
export const VN_BANKS = [
  { bin: '970436', short: 'Vietcombank',  full: 'Ngân hàng TMCP Ngoại thương Việt Nam' },
  { bin: '970418', short: 'BIDV',         full: 'Ngân hàng Đầu tư và Phát triển Việt Nam' },
  { bin: '970405', short: 'Agribank',     full: 'Ngân hàng Nông nghiệp và Phát triển Nông thôn' },
  { bin: '970415', short: 'VietinBank',   full: 'Ngân hàng TMCP Công Thương Việt Nam' },
  { bin: '970422', short: 'MB Bank',      full: 'Ngân hàng TMCP Quân Đội' },
  { bin: '970407', short: 'Techcombank',  full: 'Ngân hàng TMCP Kỹ Thương Việt Nam' },
  { bin: '970432', short: 'VPBank',       full: 'Ngân hàng TMCP Việt Nam Thịnh Vượng' },
  { bin: '970423', short: 'TPBank',       full: 'Ngân hàng TMCP Tiên Phong' },
  { bin: '970403', short: 'Sacombank',    full: 'Ngân hàng TMCP Sài Gòn Thương Tín' },
  { bin: '970437', short: 'HDBank',       full: 'Ngân hàng TMCP Phát triển TP.HCM' },
  { bin: '970448', short: 'OCB',          full: 'Ngân hàng TMCP Phương Đông' },
  { bin: '970454', short: 'VIB',          full: 'Ngân hàng TMCP Quốc tế Việt Nam' },
  { bin: '970443', short: 'SHB',          full: 'Ngân hàng TMCP Sài Gòn - Hà Nội' },
  { bin: '970441', short: 'VietinBank',   full: 'Ngân hàng TMCP Công thương' },
  { bin: '970426', short: 'MSB',          full: 'Ngân hàng TMCP Hàng Hải' },
  { bin: '970429', short: 'SCB',          full: 'Ngân hàng TMCP Sài Gòn' },
  { bin: '970433', short: 'VietBank',     full: 'Ngân hàng TMCP Việt Nam Thương tín' },
  { bin: '970438', short: 'BaoViet Bank', full: 'Ngân hàng TMCP Bảo Việt' },
]
